import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d73bbed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-game-root" }
const _hoisted_2 = { class: "game-header" }
const _hoisted_3 = { class: "table-name" }
const _hoisted_4 = ["data-tooltip"]
const _hoisted_5 = { class: "table-round" }
const _hoisted_6 = { class: "user-name" }
const _hoisted_7 = { class: "user-balance" }
const _hoisted_8 = {
  key: 1,
  class: "user-control-btns"
}
const _hoisted_9 = { class: "value-btns" }
const _hoisted_10 = { class: "value-btns" }
const _hoisted_11 = { class: "value-btns" }
const _hoisted_12 = { class: "value-btns" }
const _hoisted_13 = { class: "value-btns" }
const _hoisted_14 = { class: "value-btns" }
const _hoisted_15 = {
  key: 5,
  class: "btn-s"
}
const _hoisted_16 = { class: "value-btns" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fill" }, null, -1))
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "m-header" }
const _hoisted_20 = { class: "m-user-name" }
const _hoisted_21 = { class: "m-user-balance" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-h-fill" }, null, -1))
const _hoisted_23 = { class: "content" }
const _hoisted_24 = { class: "video-and-bet-view-group" }
const _hoisted_25 = { class: "video-area-group" }
const _hoisted_26 = {
  key: 0,
  class: "video-loader"
}
const _hoisted_27 = { class: "type-game-id" }
const _hoisted_28 = ["data-tooltip"]
const _hoisted_29 = { class: "value-btns" }
const _hoisted_30 = { class: "value-btns" }
const _hoisted_31 = { class: "value-btns" }
const _hoisted_32 = { class: "value-btns" }
const _hoisted_33 = { class: "value-btns" }
const _hoisted_34 = { class: "value-btns" }
const _hoisted_35 = {
  key: 5,
  class: "btn-s"
}
const _hoisted_36 = {
  key: 6,
  class: "btn-s btn-switch-playmode"
}
const _hoisted_37 = {
  key: 4,
  class: "is-reserved"
}
const _hoisted_38 = { class: "bet-view-group-others" }
const _hoisted_39 = { class: "road-summary-group" }
const _hoisted_40 = { class: "road-summary" }
const _hoisted_41 = ["data-label"]
const _hoisted_42 = ["data-label"]
const _hoisted_43 = ["data-label"]
const _hoisted_44 = ["data-label"]
const _hoisted_45 = ["data-label"]
const _hoisted_46 = { class: "limit-info" }
const _hoisted_47 = { class: "limit-info-title" }
const _hoisted_48 = { class: "limit-row" }
const _hoisted_49 = { class: "limit-item" }
const _hoisted_50 = { class: "limit-label" }
const _hoisted_51 = { class: "limit-value" }
const _hoisted_52 = { class: "limit-item" }
const _hoisted_53 = { class: "limit-label" }
const _hoisted_54 = { class: "limit-value" }
const _hoisted_55 = {
  key: 0,
  class: "limit-item"
}
const _hoisted_56 = { class: "limit-label" }
const _hoisted_57 = { class: "limit-value" }
const _hoisted_58 = {
  key: 1,
  class: "limit-item"
}
const _hoisted_59 = { class: "limit-label" }
const _hoisted_60 = { class: "limit-value" }
const _hoisted_61 = {
  key: 2,
  class: "limit-item"
}
const _hoisted_62 = { class: "limit-label" }
const _hoisted_63 = { class: "limit-value" }
const _hoisted_64 = {
  key: 3,
  class: "limit-item"
}
const _hoisted_65 = { class: "limit-label" }
const _hoisted_66 = { class: "limit-value" }
const _hoisted_67 = {
  key: 4,
  class: "limit-item"
}
const _hoisted_68 = { class: "limit-label" }
const _hoisted_69 = { class: "limit-value" }
const _hoisted_70 = {
  key: 5,
  class: "limit-item"
}
const _hoisted_71 = { class: "limit-label" }
const _hoisted_72 = { class: "limit-value" }
const _hoisted_73 = { class: "m-roadmap-summary-group" }
const _hoisted_74 = { class: "m-table-and-limit" }
const _hoisted_75 = { class: "m-summary" }
const _hoisted_76 = { class: "red" }
const _hoisted_77 = { class: "m-value" }
const _hoisted_78 = { class: "blue" }
const _hoisted_79 = { class: "m-value" }
const _hoisted_80 = { class: "green" }
const _hoisted_81 = { class: "m-value" }
const _hoisted_82 = {
  key: 0,
  class: "red"
}
const _hoisted_83 = { class: "m-value" }
const _hoisted_84 = {
  key: 1,
  class: "blue"
}
const _hoisted_85 = { class: "m-value" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-h-fill" }, null, -1))
const _hoisted_87 = { class: "other-content" }
const _hoisted_88 = { class: "pre-group" }
const _hoisted_89 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_user_l = _resolveComponent("i-user-l")!
  const _component_i_balance = _resolveComponent("i-balance")!
  const _component_i_reload_g = _resolveComponent("i-reload-g")!
  const _component_i_card = _resolveComponent("i-card")!
  const _component_i_diamond = _resolveComponent("i-diamond")!
  const _component_i_balance_g = _resolveComponent("i-balance-g")!
  const _component_icon_pause_g = _resolveComponent("icon-pause-g")!
  const _component_icon_open_card_g = _resolveComponent("icon-open-card-g")!
  const _component_icon_bubble = _resolveComponent("icon-bubble")!
  const _component_i_home = _resolveComponent("i-home")!
  const _component_icon_full_screen = _resolveComponent("icon-full-screen")!
  const _component_i_arrow_h = _resolveComponent("i-arrow-h")!
  const _component_icon_user1 = _resolveComponent("icon-user1")!
  const _component_icon_dolar = _resolveComponent("icon-dolar")!
  const _component_icon_video = _resolveComponent("icon-video")!
  const _component_icon_audio = _resolveComponent("icon-audio")!
  const _component_icon_zoom = _resolveComponent("icon-zoom")!
  const _component_icon_arrow_fill_left = _resolveComponent("icon-arrow-fill-left")!
  const _component_ctrl_bet_box_group = _resolveComponent("ctrl-bet-box-group")!
  const _component_ctrl_chips = _resolveComponent("ctrl-chips")!
  const _component_m_bead = _resolveComponent("m-bead")!
  const _component_m_prediction = _resolveComponent("m-prediction")!
  const _component_road_map = _resolveComponent("road-map")!
  const _component_d_prediction = _resolveComponent("d-prediction")!
  const _component_card_preview_result = _resolveComponent("card-preview-result")!
  const _component_card_game_result = _resolveComponent("card-game-result")!
  const _component_m_card_result = _resolveComponent("m-card-result")!
  const _component_marquee_text = _resolveComponent("marquee-text")!
  const _component_switch_table = _resolveComponent("switch-table")!
  const _component_good_road_panel = _resolveComponent("good-road-panel")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.tableName), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["timer-count-down", _ctx.timerColor])
      }, _toDisplayString(_ctx.currentCount >= 0 ? _ctx.currentCount : _ctx.t('game.settling')), 3),
      (_ctx.goodRoadName)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "good-road-label",
            "data-tooltip": _ctx.goodRoadName
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.goodRoadName), 1)
          ], 8, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('game.shoeround')) + ":" + _toDisplayString(_ctx.shoeRound), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_i_user_l, { class: "icon user-l" }),
        _createTextVNode(" " + _toDisplayString(_ctx.user), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_i_balance, { class: "icon balance" }),
        _createTextVNode(" " + _toDisplayString(_ctx.coin), 1)
      ]),
      (_ctx.showTableControls)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.userCommandType === 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "btn-s",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.callOperatStatus(1)), ["prevent"]))
                }, [
                  _createVNode(_component_i_reload_g, { class: "icon-btns" }),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t('game.changeshoe')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.userCommandType === 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "btn-s",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callFlyBet && _ctx.callFlyBet(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_i_card, { class: "icon-btns" }),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('game.freegame')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.tableCanReserved)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "btn-s",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callReservedOrCancellReserved && _ctx.callReservedOrCancellReserved(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_i_diamond, { class: "icon-btns" }),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.vipButtontext), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "btn-s",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showTipBox && _ctx.showTipBox(...args)), ["prevent"]))
            }, [
              _createVNode(_component_i_balance_g, { class: "icon-btns" }),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('game.tip')), 1)
            ]),
            (_ctx.userCommandType === 2 && _ctx.isYoureReserved)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "btn-s",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callPauseRequest && _ctx.callPauseRequest(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_icon_pause_g, { class: "icon-btns" }),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.t('game.pause')), 1)
                ]))
              : _createCommentVNode("", true),
            (
                    (_ctx.isYoureReserved &&
                        _ctx.enableOpenPokerOP &&
                        _ctx.enableOpenPoker) ||
                    (_ctx.userCommandType === 1 && _ctx.enableOpenPokerOP)
                )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: "btn-s",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callOpenPokeRequest && _ctx.callOpenPokeRequest(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_icon_open_card_g, { class: "icon-btns" }),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('game.opencard')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.userCommandType === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", {
                    class: "value-btns",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callGunnerFunc && _ctx.callGunnerFunc(...args)), ["prevent"]))
                  }, _toDisplayString(_ctx.callGunnerText), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 6,
                  class: "btn-s btn-switch-playmode",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchPlayMode && _ctx.switchPlayMode(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t('dialogs.gameplay.switchplaymode')), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_17,
      _createVNode(_component_icon_bubble, {
        class: "badge-bubble",
        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.showGoodRoadPanel = true), ["stop"])),
        count: _ctx.goodRoadCount
      }, null, 8, ["count"]),
      _createVNode(_component_i_home, {
        class: "icon-home",
        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'loby' })), ["prevent"]))
      }),
      (_ctx.fullScreenAvailable)
        ? (_openBlock(), _createBlock(_component_icon_full_screen, {
            key: 2,
            class: "icon-full",
            "is-on": !_ctx.isfullScreen,
            onClick: _withModifiers(_ctx.requestFullScreen, ["prevent"])
          }, null, 8, ["is-on", "onClick"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "drop-down-setting",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showSettingDialog && _ctx.showSettingDialog(...args)))
      }, [
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.t('game.menu')), 1),
        _createVNode(_component_i_arrow_h, { class: "icon-arrow" })
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_i_home, {
        class: "m-icon-home",
        onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'loby' })), ["prevent"]))
      }),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_icon_user1, { class: "m-icon user-l" }),
        _createTextVNode(" " + _toDisplayString(_ctx.user), 1)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_icon_dolar, { class: "m-icon balance" }),
        _createTextVNode(" " + _toDisplayString(_ctx.coin), 1)
      ]),
      _hoisted_22,
      (_ctx.gameTable && _ctx.gameTable.status === 4)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["m-timer", _ctx.timerColor])
          }, null, 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["m-timer", _ctx.timerColor])
          }, _toDisplayString(_ctx.currentCount >= 0 ? _ctx.currentCount : _ctx.t('game.settling')), 3)),
      _createVNode(_component_icon_bubble, {
        class: "badge-bubble",
        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.showGoodRoadPanel = true), ["stop"])),
        count: _ctx.goodRoadCount
      }, null, 8, ["count"]),
      _createElementVNode("div", {
        class: "m-drop-down-setting",
        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.showSettingDialog && _ctx.showSettingDialog(...args)))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.t('game.menu')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("video", {
            id: "player2",
            muted: "",
            autoplay: "",
            playsinline: "",
            "webkit-playsinline": "",
            disablepictureinpicture: "",
            class: _normalizeClass({
                        'scale-video': _ctx.isScaleVideo,
                        'is-half-zoom':
                            _ctx.desk === 30 || _ctx.desk === 17 || _ctx.desk === 16
                    })
          }, null, 2),
          (_ctx.isLoadingVideo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.commandTypeAndGameId), 1),
          (_ctx.goodRoadName)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "good-road-label",
                "data-tooltip": _ctx.goodRoadName
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.goodRoadName), 1)
              ], 8, _hoisted_28))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002' && (_ctx.rebateType !== 1 && _ctx.rebateType !== 3))
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["btn-toggle-game-mode", { disabled: !_ctx.allowToggleGameMode }])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({ active: !_ctx.isFreeBaccarat }),
                  onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.tooggleGameMode(false)), ["prevent"]))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t('game.baccarat')), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass({ active: _ctx.isFreeBaccarat }),
                  onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.tooggleGameMode(true)), ["prevent"]))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t('game.commissionfreebaccarat')), 1)
                ], 2)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "switch-table",
            onClick: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hideSwitchTable && _ctx.hideSwitchTable(...args)), ["prevent"]))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t('game.switchtable')), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["media-control-group", { disabled: _ctx.showMediaControl }])
          }, [
            _createVNode(_component_icon_video, {
              class: "icon-video",
              "is-on": _ctx.deskVideoOn,
              onClick: _withModifiers(_ctx.onToggleVideo, ["prevent"])
            }, null, 8, ["is-on", "onClick"]),
            _createVNode(_component_icon_audio, {
              class: "icon-sound",
              "is-on": _ctx.soundIsOn,
              onClick: _withModifiers(_ctx.toggleSoundEffect, ["prevent"])
            }, null, 8, ["is-on", "onClick"]),
            _createVNode(_component_icon_zoom, {
              class: "icon-zoom",
              "is-on": !_ctx.isScaleVideo,
              onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.isScaleVideo = !_ctx.isScaleVideo), ["prevent"]))
            }, null, 8, ["is-on"]),
            _createElementVNode("div", {
              class: "toggle-media",
              onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (
                            _ctx.showMediaControl = !_ctx.showMediaControl
                            ), ["prevent"]))
            }, [
              _createVNode(_component_icon_arrow_fill_left)
            ])
          ], 2),
          (_ctx.showTableControls)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: _normalizeClass(["m-user-control-btns", { active: _ctx.showMobileFunctionControls }])
              }, [
                _createElementVNode("div", null, [
                  (_ctx.userCommandType === 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "btn-s",
                        onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.callOperatStatus(1)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.t('game.changeshoe')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.userCommandType === 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "btn-s",
                        onClick: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callFlyBet && _ctx.callFlyBet(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.t('game.freegame')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.tableCanReserved)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "btn-s",
                        onClick: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callReservedOrCancellReserved && _ctx.callReservedOrCancellReserved(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.vipButtontext), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "btn-s",
                    onClick: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showTipBox && _ctx.showTipBox(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.t('game.tip')), 1)
                  ]),
                  (_ctx.userCommandType === 2 && _ctx.isYoureReserved)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: "btn-s",
                        onClick: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callPauseRequest && _ctx.callPauseRequest(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.t('game.pause')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (
                                (_ctx.isYoureReserved &&
                                    _ctx.enableOpenPokerOP &&
                                    _ctx.enableOpenPoker) ||
                                (_ctx.userCommandType === 1 && _ctx.enableOpenPokerOP)
                            )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 4,
                        class: "btn-s",
                        onClick: _cache[24] || (_cache[24] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callOpenPokeRequest && _ctx.callOpenPokeRequest(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.t('game.opencard')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.userCommandType === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("div", {
                          class: "value-btns",
                          onClick: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callGunnerFunc && _ctx.callGunnerFunc(...args)), ["prevent"]))
                        }, _toDisplayString(_ctx.callGunnerText), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.gameType === 'G002')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("div", {
                          class: "value-btns",
                          onClick: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchPlayMode && _ctx.switchPlayMode(...args)), ["prevent"]))
                        }, _toDisplayString(_ctx.t('dialogs.gameplay.switchplaymode')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: "m-btns-play",
                  onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (
                            _ctx.showMobileFunctionControls =
                            !_ctx.showMobileFunctionControls
                            ), ["prevent"]))
                }, [
                  _createVNode(_component_icon_arrow_fill_left)
                ])
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.isReserved)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_38, [
          (_openBlock(), _createBlock(_component_ctrl_bet_box_group, {
            class: "bet-view-group",
            gameType: _ctx.gameType,
            mData: _ctx.gameTable,
            key: _ctx.betViewKey,
            "is-free-baccarat": _ctx.isFreeBaccarat,
            ref: "refBetGroup",
            onOnUpdate: _ctx.onPlaceTempBetOrClear,
            onOnBetSuccess: _ctx.onBetSuccess,
            onOnBetmodeChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.onBetModeChange($event)))
          }, null, 8, ["gameType", "mData", "is-free-baccarat", "onOnUpdate", "onOnBetSuccess"])),
          (_ctx.showChipControls)
            ? (_openBlock(), _createBlock(_component_ctrl_chips, {
                key: 0,
                class: "chips-group"
              }))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "btn-join-table",
                onClick: _cache[29] || (_cache[29] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.joinTable && _ctx.joinTable(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.btnJoinTableLabel), 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", {
            class: "road-map-summary-item",
            "data-color": "red",
            "data-label": _ctx.gameType === 'G002'
                        ? _ctx.t('roadmap.banker')
                        : _ctx.t('roadmap.dragon')
                        
          }, _toDisplayString(_ctx.redCount), 9, _hoisted_41),
          _createElementVNode("div", {
            class: "road-map-summary-item",
            "data-color": "blue",
            "data-label": _ctx.gameType === 'G002'
                        ? _ctx.t('roadmap.player')
                        : _ctx.t('roadmap.tiger')
                        
          }, _toDisplayString(_ctx.blueCount), 9, _hoisted_42),
          _createElementVNode("div", {
            class: "road-map-summary-item",
            "data-color": "green",
            "data-label": _ctx.t('roadmap.tie')
          }, _toDisplayString(_ctx.greenCount), 9, _hoisted_43),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "road-map-summary-item",
                "data-color": "red",
                "data-label": _ctx.t('roadmap.pair')
              }, _toDisplayString(_ctx.redPairCount), 9, _hoisted_44))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "road-map-summary-item",
                "data-color": "blue",
                "data-label": _ctx.t('roadmap.pair')
              }, _toDisplayString(_ctx.bluePairCount), 9, _hoisted_45))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.t('game.limit')), 1),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.gameType === 'G002'
                                    ? _ctx.t('game.g2limit')
                                    : _ctx.t('game.g1limit')), 1),
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.redBlueLimit), 1)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.t('game.tielimit')), 1),
              _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.greenLimit), 1)
            ]),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.t('game.pairlimit')), 1),
                  _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.pairLimit), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.t('game.super6limit')), 1),
                  _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.superSixLimit), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.t('game.dragon7limit')), 1),
                  _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.dragonSevenLimit), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                  _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.t('game.bear8limit')), 1),
                  _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.bearEightLimit), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.t('game.bigtigerlimit')), 1),
                  _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.bigTigerLimit), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.gameType === 'G002')
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.t('game.smalltigerlimit')), 1),
                  _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.smallTigerLimit), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", null, _toDisplayString(_ctx.tableName), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.redBlueLimit), 1)
        ]),
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _createVNode(_component_m_bead, {
              class: "bead",
              color: 1,
              label: _ctx.gameType === 'G002'
                            ? _ctx.t('roadmap.banker')
                            : _ctx.t('roadmap.dragon')
                            
            }, null, 8, ["label"]),
            _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.roadMapData.redCount), 1)
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createVNode(_component_m_bead, {
              class: "bead",
              color: 3,
              label: _ctx.gameType === 'G002'
                            ? _ctx.t('roadmap.player')
                            : _ctx.t('roadmap.tiger')
                            
            }, null, 8, ["label"]),
            _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.roadMapData.blueCount), 1)
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createVNode(_component_m_bead, {
              class: "bead",
              color: 2,
              label: _ctx.t('roadmap.tie')
            }, null, 8, ["label"]),
            _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.roadMapData.tieCount), 1)
          ]),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                _createVNode(_component_m_bead, {
                  class: "bead",
                  color: 1,
                  label: _ctx.t('roadmap.pair')
                }, null, 8, ["label"]),
                _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.roadMapData.redPairCount), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                _createVNode(_component_m_bead, {
                  class: "bead",
                  color: 3,
                  label: _ctx.t('roadmap.pair')
                }, null, 8, ["label"]),
                _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.roadMapData.bluePairCount), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_86,
        _createVNode(_component_m_prediction, {
          class: "m-pre",
          gameType: _ctx.gameType === 'G002' ? 1 : 2,
          color: 1,
          mapdata: _ctx.nextRedRoadMapSummaryData,
          onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.predict(1)), ["prevent"]))
        }, null, 8, ["gameType", "mapdata"]),
        _createVNode(_component_m_prediction, {
          class: "m-pre",
          gameType: _ctx.gameType === 'G002' ? 1 : 2,
          color: 2,
          mapdata: _ctx.nextBlueRoadMapSummaryData,
          onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.predict(2)), ["prevent"]))
        }, null, 8, ["gameType", "mapdata"])
      ])
    ]),
    _createElementVNode("div", _hoisted_87, [
      (_openBlock(), _createBlock(_component_road_map, {
        ref: "roadmapview1",
        class: "road-map",
        "bead-row-count": _ctx.numRows,
        mapData: _ctx.mapData,
        key: _ctx.deskMapKey,
        enablePrediction: true,
        onRoadMapData: _ctx.onRoadMapDataParsed,
        onRoadResultPreview: _ctx.handleOnMapPreview,
        enableClicked: _ctx.deviceOrientation === 'landscape',
        gameType: _ctx.gameType === 'G002' ? 1 : 2
      }, null, 8, ["bead-row-count", "mapData", "onRoadMapData", "onRoadResultPreview", "enableClicked", "gameType"])),
      _createElementVNode("div", _hoisted_88, [
        _createVNode(_component_d_prediction, {
          class: "pre",
          gameType: _ctx.gameType === 'G002' ? 1 : 2,
          color: 1,
          mapdata: _ctx.nextRedRoadMapSummaryData,
          onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (_ctx.predict(1)), ["prevent"]))
        }, null, 8, ["gameType", "mapdata"]),
        _createVNode(_component_d_prediction, {
          class: "pre",
          gameType: _ctx.gameType === 'G002' ? 1 : 2,
          color: 2,
          mapdata: _ctx.nextBlueRoadMapSummaryData,
          onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.predict(2)), ["prevent"]))
        }, null, 8, ["gameType", "mapdata"])
      ]),
      _createVNode(_Transition, { name: "fadein-out" }, {
        default: _withCtx(() => [
          (_ctx.showResultPreview)
            ? (_openBlock(), _createBlock(_component_card_preview_result, {
                key: 0,
                class: "card-preview",
                onClose: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showResultPreview = false))
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.showCardDisplay && _ctx.deviceOrientation === 'landscape')
        ? (_openBlock(), _createBlock(_component_card_game_result, {
            class: "game-result",
            gameType: _ctx.gameType === 'G002' ? 1 : 2,
            info: _ctx.cardResultData,
            key: `p-r-${_ctx.cardResultKey}`
          }, null, 8, ["gameType", "info"]))
        : _createCommentVNode("", true),
      (_ctx.showCardDisplay && _ctx.deviceOrientation === 'portrait')
        ? (_openBlock(), _createBlock(_component_m_card_result, {
            class: "m-card-result",
            gameType: _ctx.gameType === 'G002' ? 1 : 2,
            info: _ctx.cardResultData,
            key: `m-r-${_ctx.cardResultKey}`
          }, null, 8, ["gameType", "info"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_89, [
      (_openBlock(), _createBlock(_component_marquee_text, {
        class: "notice",
        key: _ctx.deskNoticeKey,
        speed: 15
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.deskNotice), 1)
        ]),
        _: 1
      }))
    ]),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withCtx(() => [
        (_ctx.showSwitchDesk)
          ? _withDirectives((_openBlock(), _createBlock(_component_switch_table, {
              key: 0,
              class: "switch-table",
              onEnterTable: _ctx.onSwitchTable,
              onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.showSwitchDesk = false))
            }, null, 8, ["onEnterTable"])), [
              [_directive_click_outside, _ctx.hideSwitchTable]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withCtx(() => [
        (_ctx.showGoodRoadPanel)
          ? _withDirectives((_openBlock(), _createBlock(_component_good_road_panel, {
              key: 0,
              class: "good-road-panel",
              onClose: _cache[36] || (_cache[36] = ($event: any) => (_ctx.showGoodRoadPanel = false)),
              onOnGoodRoadSync: _ctx.onGoodRoadSync,
              "is-free-baccarat": _ctx.isFreeBaccarat
            }, null, 8, ["onOnGoodRoadSync", "is-free-baccarat"])), [
              [_directive_click_outside, _ctx.hideGoodRoadPanel]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}